// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2EEkv","icon":"style_icon__3Jmd5","title":"style_title__tYoqS"};